import React from "react";
import { Route, Redirect, useLocation } from "react-router-dom";
import { useAuth } from "react-oidc-context";
import { Loader } from "semantic-ui-react";
import { LoginInfo } from "../Utils/Login";

interface LegacyFrameProps {
  path: string;
  loginInfo: LoginInfo;
  children?: React.ReactNode;
}

export default function PrivateRoute(props: LegacyFrameProps) {
  let location = useLocation();
  let destination = encodeURIComponent(location.pathname + location.search);
  const auth = useAuth();

  return (
    <Route
      path={props.path}
      render={(innerprops): React.ReactNode => {
        // Check both loginInfo.id and OIDC authentication state
        // This handles the case where loginInfo might not be populated yet on page reload
        const isAuthenticated = props.loginInfo.id || (auth.isAuthenticated && auth.user);

        if (isAuthenticated) {
          return props.children;
        }

        // Only redirect if we're sure the user is not authenticated (not loading)
        if (!auth.isLoading) {
          return <Redirect to={"/?dest=" + destination} />;
        }

        // If still loading, show a loading spinner
        return (
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh'
          }}>
            <Loader active size="large">
              Checking authentication...
            </Loader>
          </div>
        );
      }}
    />
  );
}
